import {useFlagOrCookie} from "@khan/analytics-growthbook";

const WHAM_BOOST_REFERRAL_FLAG = "khanmigo-for-teachers-referral";

// returns true if the user passes the "khanmigo-for-teachers-referral"
// GrowthBook flag, OR if the user has the "khanmigo-for-teachers-referral"
// cookie set to true
export default function useWhamBoostReferralFlag(): boolean {
    return useFlagOrCookie(WHAM_BOOST_REFERRAL_FLAG);
}
